import { useTenant } from '../contexts/TenantContext';
import { useDirectory } from './useDirectory';
import { DirectoryMember } from '../types';

export interface UseNodeRosterResult {
  hasActiveNode: boolean;
  nodeId: string;
  nodeName: string;
  members: DirectoryMember[];
  isLoading: boolean;
}

export const useNodeRoster = (): UseNodeRosterResult => {
  const { node, isGlobal } = useTenant();
  const hasActiveNode = Boolean(node && !isGlobal && node.id !== 'platform-root');
  const targetNodeId = hasActiveNode ? (node?.id || '') : '';
  const { data, isLoading } = useDirectory(targetNodeId, {});

  const members: DirectoryMember[] = (data?.members || []) as DirectoryMember[];

  return {
    hasActiveNode,
    nodeId: targetNodeId,
    nodeName: node?.name || '',
    members,
    isLoading: hasActiveNode ? isLoading : false
  };
};
